import script from "./UpdateCarPopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateCarPopUp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__